module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-last-changes"
  }, [_c('b-table', {
    attrs: {
      "hover": "",
      "items": _vm.items,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(cell) {
        return [(cell.value === 'creation') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/creation.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'creation_template_set') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/creation_template_set.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'status_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/status_change.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'image_delete') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/image_delete.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'image_upload') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/image_upload.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'image_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/image_change.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'text_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/text_change.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'site_delete') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/site_delete.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'site_add') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/site_add.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'site_sort') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/site_sort.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'label_add') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/label_add.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assign_to_person') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/assign_to_person.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'translation_request') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/translation_request.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'translation_finished') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/translation_finished.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assignment_request') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/assignment_request.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assignment_feedback') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/assignment_feedback.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'assignment_finished') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/assignment_finished.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'synchronization_request') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/synchronization_request.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'synchronization') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/synchronization.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'empty_copy') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/creation.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'basedata_change') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/basedata_change.svg"),
            "alt": cell.value
          }
        }) : _vm._e(), _vm._v(" "), (cell.value === 'unknown') ? _c('img', {
          staticClass: "type-icon",
          attrs: {
            "src": require("@/assets/img/changes/error.svg"),
            "alt": cell.value
          }
        }) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323884a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/LastChanges.vue
// module id = 611
// module chunks = 0